(function() {
  'use strict';

  angular.module('events.directives', []);
})();
